import type { ContentHubEventSummaryRaw } from "@/content-hub/event-summaries/types";

import type { LinkedEventOption } from "./types";

export const isUpcomingAvailableLinkedEventOption = (
  option: LinkedEventOption,
  now = new Date()
) => {
  const eventStatus = option.status?.toLowerCase();
  const timeEnd = option.timeEnd ? Date.parse(option.timeEnd) : NaN;

  return (
    eventStatus === "live" &&
    !option.expired &&
    Number.isFinite(timeEnd) &&
    timeEnd > now.getTime()
  );
};

export const mapLinkedEventOptionToContentHubEventSummaryRaw = (
  option: LinkedEventOption,
  now = new Date()
): ContentHubEventSummaryRaw => ({
  external_id: option.id,
  slug: option.slug,
  title: option.name,
  description: option.description,
  image_url: option.fullImageUrl ?? option.imageUrl,
  logo_url: option.fullLogoUrl ?? option.logoUrl,
  time_start: option.timeStart,
  time_end: option.timeEnd,
  timezone: option.timezone,
  registration_url: option.registrationPageUrl,
  availability: isUpcomingAvailableLinkedEventOption(option, now)
    ? "available"
    : "unavailable",
});
